<template>
  <div class="table-responsive">
    <table id="table-fb-default" class="table table-bordered">
      <thead>
        <tr>
          <th>Halaman</th>
        </tr>
      </thead>
      <tbody></tbody>
    </table>
  </div>
</template>

<script>
import $ from "jquery";
export default {
  name: "FacebookPageDefault",
  data() {
    return {
      data: null,
      table: null,
    };
  },
  methods: {
    getData: function () {
      let api = process.env.VUE_APP_API_URL + "default-fb-pages";
      this.$http.get(api).then((response) => {
        if (response.status == 200) {
          this.data = response.data;
          for (let index in this.data) {
            let page =
              '<a href="https://facebook.com/' +
              this.data[index].page_id +
              '" target="__blank">' +
              this.data[index].account +
              "</a>";
            this.table.row.add([page]).node().id = this.data[index]._id.$oid;
            this.table.draw(false);
          }
        } else {
          this.data = {};
        }
      });
    },
  },
  created: function () {
    this.getData();
  },
  mounted: function () {
    this.table = $("#table-fb-default").DataTable();
  },
};
</script>

<style>
.table thead tr th {
  border-top: 1px solid rgba(222, 222, 222, 0.7);
}
</style>